import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Partners from '../components/Partners';
import WhyTrustUs from '../components/WhyTrustUs';
import Services from '../components/Services';
import Expertise from '../components/Expertise';
import Portfolio from '../components/Portfolio';
import Plans from '../components/Plans';
import Contact from '../components/Contact';
import { setPageTitle, pageTitles, pageDescriptions } from '../utils/pageTitle';
import { initializeSEOEnhancements } from '../utils/seoEnhancements';
import { useLanguage } from '../contexts/LanguageContext';

const Home = () => {
  const { language } = useLanguage();

  useEffect(() => {
    setPageTitle(pageTitles.home, pageDescriptions.home, 'home', language);
    
    // Initialize SEO enhancements for homepage
    initializeSEOEnhancements('homepage', {
      title: pageTitles.home,
      description: pageDescriptions.home,
      url: 'https://radixtechs.com/'
    });
  }, [language]);
  
  return (
    <>
      <Hero />
      <Partners />
      <WhyTrustUs />
      <Services />
      <Plans />
    </>
  );
};

export default Home;
